module.exports = __webpack_public_path__ + "img/icon.3574bad2.svg";